import { DB_KEY_PREFIXES } from '../../config/pouch-db.config';
import { Injectable } from "@angular/core";
import { DynamicsClientService } from "../dynamics-client/dynamics-client.service";
import { AuthenticationService } from "../../services/authentication.service";
import { DiskService } from "../../services/disk/disk.service";
import { fetchQueries } from "../../config/dynamics-fetchQueries";
import { IoFileService } from '@omni/services/io-file-service/io-file-service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExternallinksDataService {
  public get rawHyperlinkList() {
    return this._hyperlinks$.getValue();
  }
  private readonly _hyperlinks$ = new BehaviorSubject<any[]>([]);
  public hyperlinks$ = this._hyperlinks$.asObservable();
  constructor(
    public dynamics: DynamicsClientService,
    public authService: AuthenticationService,
    public disk: DiskService,
    private readonly file: IoFileService,
  ) {

  }

  public async syncHyperlinkData(forceFullSync: boolean = false, loadFromDBOnly: boolean = false) {
    try {
      if (!loadFromDBOnly) {
        try {
          let fetchXML = fetchQueries.hyperlinkFetchXMLs.fetchConfiguration;
          fetchXML = fetchXML.replace('{0}', this.authService.user.systemUserID);
          fetchXML = fetchXML.replace('{BUID}', this.authService.user.xBusinessUnitId);
          const res = await this.dynamics.executeFetchQuery('indskr_hyperlinks', fetchXML);
          console.log('Hyperlink list: ', res)
          // Download app icons for each hyperlink
          await Promise.all(res.map(hyperlink => this.saveIcon(hyperlink)));
          await this.disk.updateOrInsert(DB_KEY_PREFIXES.HYPERLINK_LIST, () => ({ raw: res }));
          console.log('Hyperlink list fetched and saved successfully.');
        } catch (error) {
          console.log('Error occured while fetching Hyperlink list: ' + error);
        }
      }
      this.loadOfflineHyperlinkList();
    } catch (error) {
      console.log(error);
    }
  }



  private async saveIcon(hyperlink: any) {
    let blob: string;
    let id = hyperlink.indskr_hyperlinkid;
    // let iconUrl = `externallink-icon-${id}`;
    let mimeType = 'image/png'; // Default mime type, can be changed based on actual content
    try {
      const res = await this.dynamics.retrieve(id, 'indskr_hyperlinks', ['indskr_icon']);
      if (!res?.indskr_icon) {
        console.warn(`No icon found for hyperlink ${id}`);
        hyperlink.iconUrl = undefined // Set to undefined if no icon is found;
        return;
      }
      blob = res.indskr_icon as string;
      const binary = atob(blob); // decode base64
      const len = Math.min(binary.length, 10); // limit to first 10 characters for mime type detection
      const buffer = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        buffer[i] = binary.charCodeAt(i);
      }
      mimeType = this.detectImageMime(buffer);
      blob = `data:${mimeType};base64,${blob}`;
    } catch (error) {
      console.error(`Error retrieving icon for hyperlink ${id}:`, error);
      return;
    }
    hyperlink.iconUrl = blob;
  }
  private detectImageMime(buffer) {
    const bytes = buffer.slice(0, 4).join(' '); // check first 4 bytes

    if (bytes === '137 80 78 71') return 'image/png';         // PNG
    if (bytes === '255 216 255 224' || bytes === '255 216 255 225') return 'image/jpeg'; // JPEG
    if (bytes === '71 73 70 56') return 'image/gif';          // GIF
    if (bytes === '66 77') return 'image/bmp';                // BMP
    if (bytes === '82 73 70 70') return 'image/webp';         // WEBP (needs deeper check)
    return 'application/octet-stream'; // fallback
  }
  // private async getIcon(sandboxUrl: string) {
  //   if (sandboxUrl.startsWith('sandbox://')) {
  //     sandboxUrl = sandboxUrl.replace('sandbox://', '');
  //   }
  //   let blob = await this.file.getFileFromSandboxStorage(sandboxUrl)
  //   if (!blob) {
  //     console.warn(`Icon not found in sandbox storage for ${sandboxUrl}`);
  //     return;
  //   }
  //   return URL.createObjectURL(blob);
  // }

  private async loadOfflineHyperlinkList() {
    const doc = await this.disk.retrieve(DB_KEY_PREFIXES.HYPERLINK_LIST, true);
    let hyperlinks = doc?.raw || [];
    // hyperlinks = await Promise.all(hyperlinks.map(async (hyperlink) => {
    //   if (hyperlink.iconUrl?.startsWith('sandbox://')) {
    //     hyperlink.iconUrl = await this.getIcon(hyperlink.iconUrl);
    //   } else {
    //     hyperlink.iconUrl = undefined; // Set to undefined if no icon is found
    //   }
    //   return hyperlink;
    // }));
    console.log('Loaded offline Hyperlink list: ', hyperlinks);
    if (hyperlinks.length === 0) {
      console.warn('No Hyperlink list found in offline storage.');
    }
    this._hyperlinks$.next(hyperlinks);
  }
}
